/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AdminListingSeverity,
    AdminListingSeverityFromJSON,
    AdminListingSeverityFromJSONTyped,
    AdminListingSeverityToJSON,
} from './AdminListingSeverity';

/**
 * 
 * @export
 * @interface AdminResolveAttentionResp
 */
export interface AdminResolveAttentionResp {
    /**
     * 
     * @type {string}
     * @memberof AdminResolveAttentionResp
     */
    resolvedUntil: string;
    /**
     * 
     * @type {AdminListingSeverity}
     * @memberof AdminResolveAttentionResp
     */
    severityAt: AdminListingSeverity;
}



export function AdminResolveAttentionRespFromJSON(json: any): AdminResolveAttentionResp {
    return AdminResolveAttentionRespFromJSONTyped(json, false);
}

export function AdminResolveAttentionRespFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminResolveAttentionResp {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resolvedUntil': json['resolvedUntil'],
        'severityAt': AdminListingSeverityFromJSON(json['severityAt']),
    };
}

export function AdminResolveAttentionRespToJSON(value?: AdminResolveAttentionResp | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'resolvedUntil': value.resolvedUntil,
        'severityAt': AdminListingSeverityToJSON(value.severityAt),
    };
}

